import React from 'react';

const CompleteStep: React.FC = () => {
  return(
    <>
      <div className='bill-container-fit-screen-content'>
        <div className='loading-spinner-cont'>
          <p>Select a step to view details</p>
        </div>
      </div>
    </>
  );
};
export default CompleteStep;
